import React, { useEffect, useState } from "react";
import { PageContainer } from "../components/Container/PageContainer";
import { Grid, Title, Text, Flex, Table } from "@mantine/core";
import { dbService } from "../firebaseInstance";
import { Image } from "@mantine/core";
import moment from "moment";

const Admin = () => {
	const [users, setUsers] = useState([]);
	const [sortConfig, setSortConfig] = useState({
		key: "visitCount",
		order: "asc",
	});

	useEffect(() => {
		const fetchUsers = async () => {
			const userDocRef = dbService.collection("user");
			const userDoc = await userDocRef.get();
			const usersData = [];

			for (const doc of userDoc.docs) {
				const userData = doc.data();
				const userInsightDoc = await doc.ref
					.collection("insight")
					.doc("insight")
					.get();
				const userInsight = userInsightDoc.exists ? userInsightDoc.data() : {};
				usersData.push({ ...userData, insight: userInsight });
			}

			// Filter out users without a profile key
			const filteredUsersData = usersData.filter((user) => user.profile);

			console.log(filteredUsersData);

			setUsers(filteredUsersData);
		};

		fetchUsers();
	}, []);

	const sortUsers = (key) => {
		const order =
			sortConfig.key === key && sortConfig.order === "asc" ? "desc" : "asc";
		const sortedUsers = [...users].sort((a, b) => {
			let aValue, bValue;

			if (key === "lastVisit") {
				console.log(a);
				aValue = a.visitLog?.[a.visitLog.length - 1] ?? a.profile.signUpDate;
				bValue = b.visitLog?.[b.visitLog.length - 1] ?? b.profile.signUpDate;
				aValue = new Date(aValue);
				bValue = new Date(bValue);
			} else if (key === "signUpDate") {
				aValue = new Date(a.profile.signUpDate);
				bValue = new Date(b.profile.signUpDate);
			} else if (key === "visitCount") {
				aValue = a.visitLog?.length ?? 0;
				bValue = b.visitLog?.length ?? 0;
			} else if (key === "insight") {
				aValue = Object.keys(a.insight).length;
				bValue = Object.keys(b.insight).length;
			} else {
				aValue = a.profile[key];
				bValue = b.profile[key];
			}

			// Handle undefined or null values
			if (aValue === null) return 1;
			if (bValue === null) return -1;

			if (order === "asc") {
				return aValue - bValue;
			} else {
				return bValue - aValue;
			}
		});
		setUsers(sortedUsers);
		setSortConfig({ key, order });
	};

	return (
		<PageContainer w="100%">
				<Title order={1}>Admin Page</Title>
				<Title order={2} fw={300}>
					number of users:{" "}
					<span style={{ fontWeight: "bold" }}>{users.length} </span>
				</Title>
				<div
					style={{
						position: "relative",
						overflowY: "auto",
						maxHeight: "800px",
						width: "100%",
					}}
				>
					<Table highlightOnHover withBorder withColumnBorders w="100%">
						<Table.Thead
							style={{
								position: "sticky",
								top: 0,
								backgroundColor: "white",
								zIndex: 1,
							}}
						>
							<Table.Tr>
								<Table.Th>Profile</Table.Th>
								<Table.Th>Username</Table.Th>
								<Table.Th>Name</Table.Th>
								<Table.Th>ID</Table.Th>
								<Table.Th
									onClick={() => sortUsers("signUpDate")}
									style={{ cursor: "pointer" }}
								>
									Sign Up Date{" "}
									{sortConfig.key === "signUpDate"
										? sortConfig.order === "asc"
											? "↑"
											: "↓"
										: ""}
								</Table.Th>
								<Table.Th
									onClick={() => sortUsers("lastVisit")}
									style={{ cursor: "pointer" }}
								>
									Last Visit{" "}
									{sortConfig.key === "lastVisit"
										? sortConfig.order === "asc"
											? "↑"
											: "↓"
										: ""}
								</Table.Th>
								<Table.Th
									onClick={() => sortUsers("visitCount")}
									style={{ cursor: "pointer" }}
								>
									Visit Count{" "}
									{sortConfig.key === "visitCount"
										? sortConfig.order === "asc"
											? "↑"
											: "↓"
										: ""}
								</Table.Th>
								<Table.Th
									onClick={() => sortUsers("insight")}
									style={{ cursor: "pointer" }}
								>
									Insight{" "}
									{sortConfig.key === "insight"
										? sortConfig.order === "asc"
											? "↑"
											: "↓"
										: ""}
								</Table.Th>
							</Table.Tr>
						</Table.Thead>
						<Table.Tbody>
							{users.map((user, index) => (
								<Table.Tr key={index}>
									<Table.Td>
										<a
											href={`https://threads.net/@${user?.profile?.username}`}
											target="_blank"
											rel="noreferrer"
										>
											<Image
												w={32}
												h={32}
												radius="xl"
												src={user?.profile?.threads_profile_picture_url}
												alt="Profile"
											/>
										</a>
									</Table.Td>
									<Table.Td fz={16}>{user?.profile?.username}</Table.Td>
									<Table.Td fz={16}>{user?.profile?.name}</Table.Td>
									<Table.Td fz={16}>{user?.profile?.id}</Table.Td>
									<Table.Td fz={16}>
										{moment(user?.profile?.signUpDate).format("MM/DD/YYYY")}
									</Table.Td>
									<Table.Td>
										{user?.visitLog && user?.visitLog?.length > 0 ? (
											<Flex direction="row" align="center" gap={8}>
												<Text fz={16}>
													{moment(
														user?.visitLog[user?.visitLog?.length - 1]
													).format("MM/DD hh:mm A")}
												</Text>
											</Flex>
										) : (
											<Flex direction="row" align="center" gap={8}>
												<Text fz={16}>
													{moment(user?.profile?.signUpDate).format(
														"MM/DD hh:mm A"
													)}
												</Text>
											</Flex>
										)}
									</Table.Td>
									<Table.Td>
										<Flex direction="row" align="center" gap={8}>
											<Text fz={16}>{user?.visitLog?.length ?? 0}</Text>
										</Flex>
									</Table.Td>
									<Table.Td>
										<Flex direction="row" align="center" gap={8}>
											<Text fz={16}>
												{Object.keys(user?.insight).length > 0 ? "Yes" : "No"}
											</Text>
										</Flex>
									</Table.Td>
								</Table.Tr>
							))}
						</Table.Tbody>
					</Table>
				</div>
		</PageContainer>
	);
};

export default Admin;
